var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppBar, Container, Toolbar, useTheme } from '@mui/material';
import { FlexGrowRow } from '../FlexBox';
const AppBarEx = (props) => {
    const { contextToolbar, systemToolbar, container, style } = props, appbarProps = __rest(props, ["contextToolbar", "systemToolbar", "container", "style"]);
    const theme = useTheme();
    const AppBarExInner = () => {
        return (_jsxs(FlexGrowRow, Object.assign({ justifyContent: "space-between" }, { children: [contextToolbar !== null && contextToolbar !== void 0 ? contextToolbar : _jsx(Toolbar, {}, void 0), systemToolbar !== null && systemToolbar !== void 0 ? systemToolbar : _jsx(Toolbar, {}, void 0)] }), void 0));
    };
    return (_jsx(AppBar, Object.assign({ position: "static", style: Object.assign({ backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary, display: 'flex' }, style) }, appbarProps, { children: container ? (_jsx(Container, Object.assign({ maxWidth: container }, { children: _jsx(AppBarExInner, {}, void 0) }), void 0)) : (_jsx(AppBarExInner, {}, void 0)) }), void 0));
};
export default AppBarEx;
//# sourceMappingURL=AppBarEx.js.map